import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// img
import si1 from "../../../Assets/images/si1.png";
import { CstmPagination } from "../../../components/Common/Common";
import { GET_SERVICES, SELECT_SERVICE } from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import Table from "../../../components/Common/Table";
import CustomPagination from "../../../components/Common/CustomPagination";
import ImgPop from "../../../components/Modals/ImgPop";

const ManageService = () => {
  const [services, setServices] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(false);

  //

  const [imgPreview, setImgPreview] = useState("");

  const [body, setBody] = useState({
    page: 1,
    limit: 10,
    orderBy: "createdAt",
    order: -1,
    search: "",
    status: "all",
  });

  const getServices = async () => {
    setLoader(true);
    try {
      const res = await GET_SERVICES(body);

      if (res?.data?.status === "success") {
        setServices(res?.data?.data);
        setTotalCount(res?.data?.totalcount);
        setLoader(false);
      } else {
        toast.error(res?.data?.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);

      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    getServices();
  }, []);
  const pageChangeHandler = (page) => {
    const newBody = {
      ...body,
      page,
    };
    setBody(newBody);

    getServices(newBody);
  };
  const selectServiceHandler = async (e, serviceId, ind) => {
    const oldServices = [...services];
    const newServices = JSON.parse(JSON.stringify(services));

    newServices[ind].allowedByAgency = e.target.checked;
    setServices(newServices);

    try {
      const res = await SELECT_SERVICE({
        serviceId,
        allowService: e.target.checked,
      });

      if (res?.data?.status !== "success") {
        setServices(oldServices);
        toast.error(res?.data?.message);
      }
    } catch (error) {
      setServices(oldServices);
      toast.error("something went wrong");
    }
  };

  const col = [
    {
      label: "Sr no",
      id: "srNo",
      isComponent: true,
      component: (_, key) => (
        <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
      ),
    },
    {
      label: "Service Name",
      id: "name",
    },
    {
      label: "Service Description",
      id: "shortDesc",
    },
    {
      label: "Service Image",
      id: "",
      isComponent: true,
      component: (item, arr) => (
        <img
          src={item?.image || si1}
          onClick={() => setImgPreview(item?.image)}
          alt=""
          className="img-fluid"
          width={60}
          height={60}
          style={{ cursor: "pointer" }}
        />
      ),
    },
    {
      label: "Base Fare",
      id: "baseFareforservice",
      classNames: "m-0 fw-sbold",
    },
    {
      label: "Action",
      id: "baseFare",

      isComponent: true,
      component: (item, ind) => (
        <input
          type="checkbox"
          className="form-check"
          checked={item.allowedByAgency}
          onClick={(e) => selectServiceHandler(e, item._id, ind)}
        />
      ),
    },
  ];

  return (
    <>
      <ImgPop imgPreview={imgPreview} setImgPreview={setImgPreview} />
      <section className="manageDriver py-2 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Manage Service</h3>
                <p className="m-0 text-muted fw-sbold">
                  Select the services you provide
                </p>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="table-responsive">
                <Table data={services} loader={loader} column={col} />
                <div className="d-flex align-items-center justify-content-between">
                  <div className="left">
                    <p className="m-0 fw-sbold themeBlue">
                      {/* Select{" "} */}
                      {services.reduce((prev, current) => {
                        return current.allowedByAgency ? prev + 1 : prev;
                      }, 0)}{" "}
                      Services Selected
                    </p>
                  </div>
                  <div className="right">
                    <CustomPagination
                      total={totalCount}
                      pageChangeHandler={pageChangeHandler}
                      pageSize={body.limit}
                      current={body.page}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageService;
